import { useFirestore } from "@/hooks/firestore/core/useFirestore";
import {
  GAME_SESSION_STATUSES,
  gameSession,
} from "@/features/casino/models/gameSession";
import { useFiatCurrency } from "@/hooks/firestore/user/useFiatCurrency";
import { where } from "firebase/firestore";

const useGameSessions = (activeOnly?: boolean, gameId?: string) => {
  const currency = useFiatCurrency();
  const { data, error, isLoading } = useFirestore(
    `/users/{userId}/casinoDetails/${currency}/gameSessions`,
    gameSession.array(),
    {
      keyPath: "id",
      ...(activeOnly || gameId
        ? {
            query: [
              ...(activeOnly
                ? [
                    where(
                      "gameSessionStatus",
                      "==",
                      GAME_SESSION_STATUSES.ACTIVE,
                    ),
                  ]
                : []),
              ...(gameId ? [where("gameId", "==", gameId)] : []),
            ],
          }
        : {}),
    },
  );

  return {
    hasActiveGameSession:
      (data || [])?.filter(
        (session) => session.gameSessionStatus === GAME_SESSION_STATUSES.ACTIVE,
      ).length > 0,
    data,
    error,
    isLoading,
  } as const;
};

export { useGameSessions };
